export default "__VITE_ASSET__B2RCU_eE__"